import React from "react";
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import Logo from '../main-header/logo/Logo';
import SidebarMenu from "../../header-mobile/sidebar/SidebarMenu";

const VerticalNav = (props) => {

    const { componentSetting } = useSelector((state) => ({
        componentSetting: state.componentSettingListR.data,
    }));
    return (

        <div className='vertical-nav'>
            {typeof componentSetting?.["top-nav-logo"] != 'undefined' && componentSetting?.["top-nav-logo"]?.["default-value"] && <Logo />}
            <SidebarMenu desktop={true} handleClose={props?.handleClose} />

        </div>
    )
}

VerticalNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(VerticalNav);